// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"8ecc3682","695":"1e5fecce"}[chunkId] + ".chunk.js";
};